import React from "react";
import styles from "./footer.module.css";

function Footer() {
  return (
    <div>
      <p className={styles.copyright}>Copyright © 2021 - Ayoub Bouya Ukraine</p>
    </div>
  );
}

export default Footer;
